import React from "react"
import { useTranslation } from 'react-i18next'
import { Offcanvas } from 'react-bootstrap'

import { formatDateWithTime } from 'helpers/helpers'

import { currencyLabel, expenseAccountName, expenseDetails, expenseStatus, expenseTotal, formatAmount, responsibleName } from './financeUtils'

function DetailRow({ icon, label, children }) {
	return (
		<div className="fo-detail-row">
			<div className="fo-detail-label text-muted">
				<i className={'uil ' + icon + ' me-2'}></i>
				{label}
			</div>
			<div>{children}</div>
		</div>
	)
}

function Preview({ show, item, onHide }) {
	const { t } = useTranslation()

	const currency = item ? currencyLabel(item.currencyId, item.currencyName) : ''
	// for a canceled expense updatedBy / updatedAt are who canceled it and when
	const canceled = item ? expenseStatus(item) === 'CANCELED' : false

	return (
		<Offcanvas show={show} placement="end" className="fo-offcanvas" onHide={onHide}>
			{item &&
				<>
					<Offcanvas.Header closeButton>
						<div className="d-flex align-items-center">
							<div className="fo-icon me-3">
								<i className="uil uil-arrow-up-right"></i>
							</div>
							<div>
								
								<Offcanvas.Title>{t('FO_EXPENSE')} </Offcanvas.Title>							
							</div>
						</div>
					</Offcanvas.Header>
					<Offcanvas.Body>
						{canceled &&
							<div className="fo-canceled-banner mb-3">
								<div className="fo-canceled-title">
									<i className="uil uil-ban me-2"></i>
									{t('FO_OPERATION_CANCELED')}
								</div>
								<div className="fo-canceled-info">
									{item.updatedByFirstName &&
										<span>
											<i className="uil uil-user-times me-1"></i>
											{t('FO_CANCELED_BY')}: <b>{item.updatedByFirstName} {item.updatedByLastName}</b>
										</span>
									}
									{item.updatedAt &&
										<span>
											<i className="uil uil-clock me-1"></i>
											{formatDateWithTime(item.updatedAt)}
										</span>
									}
								</div>
							</div>
						}
						<div className="fo-amount-card mb-3">
							<div className="fo-amount-card-head">
								<div className="text-muted">{t('AMOUNT')}</div>
								<div className="fo-amount">−{formatAmount(expenseTotal(item), currency)}</div>
							</div>
							{expenseDetails(item).map(detail => Number(detail.amount) > 0 &&
								<div key={detail.id} className="fo-amount-row">
									<span>
										<i className={'uil ' + detail.paymentType.icon + ' text-muted me-2'}></i>
										{t(detail.paymentType.i18n)}
									</span>
									<span className="fw-600">{formatAmount(detail.amount, currency)}</span>
								</div>
							)}
						</div>

						<DetailRow icon="uil-receipt" label={t('TYPE')}>
							<div className="fw-600">{t('FO_OTHER_EXPENSE')}</div>
							<div className="text-muted text-sm">{item.expenseHelperName}</div>
						</DetailRow>
						{item.posName &&
							<DetailRow icon="uil-store" label={t('POS')}>
								{item.posName}
							</DetailRow>
						}
						<DetailRow icon="uil-university" label={t('ACCOUNT')}>
							<div>{expenseAccountName(item, t)}</div>
							
						</DetailRow>
						<DetailRow icon="uil-calendar-alt" label={t('DATE')}>
							{formatDateWithTime(item.createdDate)}
						</DetailRow>
						<DetailRow icon="uil-user-circle" label={t('RESPONSIBLE')}>
							{responsibleName(item)}
						</DetailRow>
						{item.updatedAt && !canceled &&
							<DetailRow icon="uil-history" label={t('UPDATED')}>
								<div>{formatDateWithTime(item.updatedAt)}</div>
								{item.updatedBy &&
									<div className="text-muted text-sm">{item.updatedBy}</div>
								}
							</DetailRow>
						}
						{item.note &&
							<DetailRow icon="uil-comment-alt-lines" label={t('COMMENT')}>
								{item.note}
							</DetailRow>
						}
					</Offcanvas.Body>
				</>
			}
		</Offcanvas>
	)
}

export default Preview
